import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userDetails } from "../../components/recoil/userDataRecoil";
import { useReadMemory } from "./hooks/useReadMemory";
import MemoryType from "../../service/memory/enum/MemoryType";

const ERROR_CODE = "1003";
let CURRENT_ROLE;

function ErrorWrapper() {
  return <Navigate to={`/error?code=${ERROR_CODE}`} replace />;
}

function RoleWrapper({ children, allowedRoles }) {
  const loggedInUser = useReadMemory(MemoryType.USER)
  CURRENT_ROLE = loggedInUser?.jobTitle;
  const user = useRecoilValue(userDetails);
  if ((allowedRoles.includes(user.jobTitle) || allowedRoles.includes(CURRENT_ROLE)) && (user?.isActive || loggedInUser?.isActive)) {
    return <>{children}</>;
  } else {
    return <ErrorWrapper />;
  }
}

export function CoordinatorWrapper({ children }) {
  return <RoleWrapper children={children} allowedRoles={["Volunteer Coordinator"]} />;
}

export function ProviderWrapper({ children }) {
  return <RoleWrapper children={children} allowedRoles={["Volunteer"]} />;
}

export function BillingAdminWrapper({ children }) {
  return <RoleWrapper children={children} allowedRoles={["Billing Admin"]} />;
}
